/** @format */

import { createSlice } from '@reduxjs/toolkit';
// import _ from 'lodash';
import axios from 'src/utils/axios';
import { ENDPOINTS } from 'src/constants';
import type { CmsPageContent, KnowledgeBaseSearchResponse } from 'src/types';

const initialState = {
  //
  knowledgeBaseLoading: false,
  knowledgeBase: null,
  //
  knowledgeBaseDetailLoading: false,
  knowledgeBaseDetail: null,
  //
  knowledgeBaseArticlesLoading: null,
  knowledgeBaseArticles: null,
  //
  categoriesLoading: false,
  categories: null,
  //
  updateKnowledgeBaseLoading: false,
  //
  ratingSuccess: false,
  ratingError: null,
  //
  error: null
};

const slice = createSlice({
  name: 'knowledgeBase',
  initialState,
  reducers: {
    //Get KnowledgeBase Info
    getKnowledgeBase(state) {
      state.knowledgeBaseLoading = true;
    },
    getKnowledgeBaseSuccess(state, action) {
      const data = action.payload;
      state.knowledgeBase = data || [];
      state.knowledgeBaseLoading = false;
    },
    getKnowledgeBaseFailure(state, action) {
      state.error = action.payload;
      state.knowledgeBaseLoading = false;
    },
    //Get KnowledgeBase Search
    getKnowledgeBaseArticles(state) {
      state.knowledgeBaseArticlesLoading = true;
    },
    getKnowledgeBaseArticlesSuccess(state, action) {
      const data = action.payload;
      state.knowledgeBaseArticles = data.articles || [];
      state.knowledgeBaseArticlesLoading = false;
    },
    getKnowledgeBaseArticlesFailure(state, action) {
      state.error = action.payload;
      state.knowledgeBaseArticlesLoading = false;
    },
    //Get KnowledgeBase Categories
    getCategories(state) {
      state.categoriesLoading = true;
    },
    getCategoriesSuccess(state, action) {
      const data = action.payload;
      state.categories = data.categories || [];
      state.categoriesLoading = false;
    },
    getCategoriesFailure(state, action) {
      state.error = action.payload;
      state.categoriesLoading = false;
    },
    getKnowledgeBaseDetail(state) {
      state.knowledgeBaseDetailLoading = true;
    },

    getKnowledgeBaseDetailSuccess(state, action) {
      const data = action.payload;
      state.knowledgeBaseDetailLoading = false;
      state.knowledgeBaseDetail = data;
    },
    getKnowledgeBaseDetailFailure(state, action) {
      state.error = action.payload;
      state.knowledgeBaseDetailLoading = false;
    },
    rateArticle(state) {
      state.knowledgeBaseDetailLoading = true;
    },
    rateArticleSuccess(state) {
      state.ratingSuccess = true;
      state.knowledgeBaseDetailLoading = false;
    },
    rateArticleFailure(state, action) {
      state.knowledgeBaseDetailLoading = false;
      state.ratingError = action.payload.error;
    },
    clearKnowledgeBasetError(state) {
      state.error = null;
      state.ratingError = null;
      state.ratingSuccess = false;
    }
  }
});

export const reducer = slice.reducer;

// KnowledgeBase Info
export const getKnowledgeBase = kb => async dispatch => {
  const { getKnowledgeBase, getKnowledgeBaseSuccess, getKnowledgeBaseFailure } = slice.actions;

  try {
    dispatch(getKnowledgeBase());
    const response = await axios.get(`${ENDPOINTS.GET_KNOWLEDGE_BASE_ENDOIUNT}/${kb}/`);
    dispatch(getKnowledgeBaseSuccess(response.data));
  } catch (err) {
    dispatch(getKnowledgeBaseFailure(err));
  }
};

export const getKnowledgeBaseArticles = params => async dispatch => {
  const { getKnowledgeBaseArticles, getKnowledgeBaseArticlesSuccess, getKnowledgeBaseFailure } = slice.actions;

  try {
    dispatch(getKnowledgeBaseArticles());
    const response = await axios.get<KnowledgeBaseSearchResponse>(`${ENDPOINTS.GET_KNOWLEDGE_BASE_ENDOIUNT}/search/`, { params });
    dispatch(getKnowledgeBaseArticlesSuccess(response.data));
  } catch (err) {
    dispatch(getKnowledgeBaseFailure(err));
  }
};

export const getKnowledgeBaseCategories = () => async dispatch => {
  const { getCategories, getCategoriesSuccess, getCategoriesFailure } = slice.actions;

  try {
    dispatch(getCategories());
    const response = await axios.get(`${ENDPOINTS.GET_KNOWLEDGE_BASE_CATEGORIES_ENDOIUNT}`);
    dispatch(getCategoriesSuccess(response.data));
  } catch (err) {
    dispatch(getCategoriesFailure(err));
  }
};

export const getKnowledgeBaseDetail = (id, noLoad) => async dispatch => {
  const { getKnowledgeBaseDetail, getKnowledgeBaseDetailSuccess, getKnowledgeBaseDetailFailure } = slice.actions;

  try {
    if (!noLoad) dispatch(getKnowledgeBaseDetail());
    const response = await axios.get<CmsPageContent>(`${ENDPOINTS.GET_PRIVATE_CONTENT_INFO_ENDPOINT}/${id}`);
    dispatch(getKnowledgeBaseDetailSuccess(response.data));
  } catch (err) {
    dispatch(getKnowledgeBaseDetailFailure(err));
  }
};

export const rateKnowledgeBaseDetail = (nid, rating) => async dispatch => {
  const { rateArticleSuccess, rateArticleFailure } = slice.actions;

  try {
    const formData = new FormData();
    formData.append('kbArticle', nid);
    formData.append('rating', rating);
    await axios.post(ENDPOINTS.GET_KNOWLEDGE_BASE_VOTE_ENDOIUNT, formData);
    dispatch(rateArticleSuccess());
    dispatch(getKnowledgeBaseDetail(nid, true));
  } catch (err) {
    dispatch(rateArticleFailure(err));
  }
};
export const clearKnowledgeBasetError = () => dispatch => {
  const { clearKnowledgeBasetError } = slice.actions;
  dispatch(clearKnowledgeBasetError());
};

export default slice;
